define( function() {
	return ( /\?/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/rquery.js
// module id = 528
// module chunks = 352